(() => {
  const config = document.querySelector('[data-ib-cookie-preferences]');
  if (!config) return;
  // Shopify's native banner currently prepends /ro despite the actual RO root URL.
  // The merchant's locale-aware page URL comes from Liquid; never guess a prefix.
  function repairLink() {
    const link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (link && link.getAttribute('href') !== config.dataset.privacyUrl) link.setAttribute('href', config.dataset.privacyUrl);
  }
  repairLink();
  new MutationObserver(repairLink).observe(document.body, {childList:true,subtree:true});
  config.addEventListener('click', async () => {
    const status = document.querySelector('[data-ib-cookie-status]');
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Banner unavailable');
      await window.privacyBanner.showPreferences();
      if (status) status.textContent = '';
    } catch {
      if (status) status.textContent = config.dataset.error;
    }
  });
})();
